module.exports = __webpack_public_path__ + "media/images/icons/sample_logo-589944e87df33bcc819c4b8c6f97412d.svg";